<template>
  <div class="report">
    <div class="distributed-header">
      <div class="distributed-logo"></div>
      <span class="school">参赛选手组成</span>
      <span class="word">Competition Contestant</span>
      <div class="header-bottom"></div>
    </div>
    <div class="report-info">
      <!-- <div class="info-header">
        <span> 报名人数:{{ allCount }}人 </span>
        <span> 签到人数：{{ confirmedCount }}人 </span>
      </div>
      <div class="eacher"></div> -->
      <img src="./../../../assets/img/pie.png">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      jianLuPersonStaticsDTOS: "",
      allCount: 0,
      confirmedCount: 0,
    };
  },
  mounted() {
    // this.getdata();
  },
  methods: {
    // getdata() {
    //   let getdata1 = ()=>{
    //     this.$axios
    //     .get("https://scgyioc.scetc.edu.cn/api/participant/statics", {})
    //     .then((response) => {
    //       this.jianLuPersonStaticsDTOS =
    //         response.data.data.queRenPersonStaticsDTOS;
    //       this.allCount = response.data.data.allCount;
    //       this.confirmedCount = response.data.data.confirmedCount;
    //       this.draw();
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    //   }
    //   getdata1();
    //   setInterval(() => {
    //     getdata1();
    //   }, 30000);
    // },
    // draw() {
    //   let myeacher = this.$echarts.init(document.querySelector(".eacher"));

    //   let option = {
    //     grid: {
    //       top: 30, //距离容器上边界40像素
    //       bottom: 30, //距离容器下边界30像素
    //     },
    //     legend: {
    //       itemWidth: 20,
    //       itemHeight: 10,
    //       textStyle: {
    //         fontSize: 10,
    //         color: "#fff",
    //       },
    //     },
    //     tooltip: {},
    //     dataset: {
    //       source: this.jianLuPersonStaticsDTOS,
    //     },
    //     xAxis: {
    //       type: "category",
    //       axisLabel: {
    //         formatter: function (params) {
    //           var newParamsName = ""; // 最终拼接成的字符串
    //           var paramsNameNumber = params.length; // 实际标签的个数
    //           var provideNumber = 4; // 每行能显示的字的个数
    //           var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
    //           /**
    //            * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
    //            */
    //           // 条件等同于rowNumber>1
    //           if (paramsNameNumber > provideNumber) {
    //             /** 循环每一行,p表示行 */
    //             for (var p = 0; p < rowNumber; p++) {
    //               var tempStr = ""; // 表示每一次截取的字符串
    //               var start = p * provideNumber; // 开始截取的位置
    //               var end = start + provideNumber; // 结束截取的位置
    //               // 此处特殊处理最后一行的索引值
    //               if (p == rowNumber - 1) {
    //                 // 最后一次不换行
    //                 tempStr = params.substring(start, paramsNameNumber);
    //               } else {
    //                 // 每一次拼接字符串并换行
    //                 tempStr = params.substring(start, end) + "\n";
    //               }
    //               newParamsName += tempStr; // 最终拼成的字符串
    //             }
    //           } else {
    //             // 将旧标签的值赋给新标签
    //             newParamsName = params;
    //           }
    //           //将最终的字符串返回
    //           return newParamsName;
    //         },
    //         interval: 0,
    //         show: true,
    //         textStyle: {
    //           color: "#b5d4ff",
    //           fontSize: 9,
    //           itemSize: "",
    //         },
    //       },
    //       axisTick: {
    //         show: false,
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           type: "solid",
    //           color: "#b5d4ff", //左边线的颜色
    //           width: "1", //坐标线的宽度
    //         },
    //       },
    //     },
    //     yAxis: {
    //       splitLine: {
    //         //网格线
    //         lineStyle: {
    //           type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
    //           color: ["#b5d4ff"],
    //         },
    //       },
    //       axisLabel: {
    //         textStyle: {
    //           color: "#b5d4ff",
    //         },
    //       },
    //       axisTick: {
    //         show: false,
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           type: "solid",
    //           color: "#b5d4ff", //左边线的颜色
    //           width: "1", //坐标线的宽度
    //         },
    //       },
    //     },

    //     series: [
    //       {
    //         type: "bar",
    //         name: "报名人数",
    //         itemStyle: {
    //           normal: {
    //             color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
    //               {
    //                 offset: 0,
    //                 color: "rgba(85,127,224,1)",
    //               },
    //               {
    //                 offset: 1,
    //                 color: "rgba(85,127,224,0)",
    //               },
    //             ]),
    //             label: {
    //               show: true, //开启显示
    //               position: "top", //在上方显示
    //               textStyle: {
    //                 //数值样式
    //                 color: "#fff",
    //                 fontSize: 10,
    //               },
    //             },
    //           },
    //         },
    //       },
    //       {
    //         type: "bar",
    //         name: "报道人数",
    //         itemStyle: {
    //           normal: {
    //             color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
    //               {
    //                 offset: 0,
    //                 color: "rgba(219,168,55,1)",
    //               },
    //               {
    //                 offset: 1,
    //                 color: "rgba(219,168,55,0)",
    //               },
    //             ]),
    //             label: {
    //               show: true, //开启显示
    //               position: "top", //在上方显示
    //               textStyle: {
    //                 //数值样式
    //                 color: "#fff",
    //                 fontSize: 10,
    //               },
    //             },
    //           },
    //         },
    //       },
    //     ],
    //   };
    //   myeacher.setOption(option);
    //   window.addEventListener("resize", () => {
    //     myeacher.resize();
    //   });
    // },
  },
};
</script>
<style scoped>
.report {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/participate-bg.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header {
  width: 100%;
  height: 10.5%;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.05rem;
  display: flex;
}
.header-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 1px;
  background: url("./../../../assets/img/distributed-line.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .distributed-logo {
  margin-top: 1%;
  width: 0.6375rem;
  background: url("./../../../assets/img/distributed-logo.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .school {
  font-size: 0.225rem;
  font-family: "pmzd";
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}
.distributed-header .word {
  font-family: "SourceHanSansCN";
  color: #9cc3ff;
  font-size: 0.15rem;
  margin-top: 1.5%;
}
.report-info {
  width: 100%;
  height: 89.5%;
  box-sizing: border-box;
  padding: 1.5%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.report-info img{
  width: 80%;
  height: 80%;
}
.info-header {
  width: 100%;
  width: 100%;
  background: url("./../../../assets/img/report-header.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 0.083333rem;
  box-sizing: border-box;
}
.info-header span {
  font-size: 0.183333rem;
  font-family: "SourceHanSansCN";
  color: #fff;
  display: block;
  display: flex;
  justify-items: center;
  overflow: hidden;
  white-space: nowrap;
}
.eacher {
  margin-top: 1%;
  height: 87%;
}
</style>